<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/insPath'}">巡检路线</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? "编辑" : "新增" }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="300px"
                    class="demo-ruleForm"
                    style="width:100%;margin:0 auto"
            >
                <el-form-item label="名称" prop="name">
                    <el-input size="small" v-model="ruleForm.name" style="width:500px"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="remark">
                    <el-input size="small"  v-model="ruleForm.remark" style="width:500px"></el-input>
                </el-form-item>
                <el-form-item label="按顺序巡检" prop="isOrder">
                    <el-radio-group v-model="isOrder" size="small" @change="checkBoxChange">
                        <el-radio-button :label="0">是</el-radio-button>
                        <el-radio-button :label="1">否</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="巡检人" prop="userIds">
                    <el-select size="small"  v-model="userIds" multiple placeholder="请添加巡检人" style="width:500px">
                        <el-option
                                v-for="item in userData"
                                :key="item.id"
                                :label="item.nickname"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="持续时间" prop="duration">
                    <el-input-number size="small"
                                     v-model="ruleForm.duration"
                            controls-position="right"
                            :min="1"
                            :max="1000000"
                    ></el-input-number>
                    <!-- <el-button>分钟</el-button> -->
                    <span style="margin-left: 10px">分钟</span>
                </el-form-item>
                <el-form-item label="巡检点" prop="emergeData1" style="padding:10px 0;">
                    <div v-if="!isShowBtn" v-for="(item1,index) in emergeData1" :key="index">
                        <el-select size="small" v-model="item1.pointId" placeholder="请添加巡检点" style="width:500px;margin-top: 1%;">
                            <el-option
                                    v-for="item in pointData"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                        <el-button size="small"
                                   type="danger"
                                icon="el-icon-delete"
                                style="margin-left:20px"
                                @click="handDelEme1(index)"
                                circle
                        ></el-button>
                    </div>
                    <el-button style="width:500px;margin-top: 1%" @click="handleAddEme1()" plain>添加</el-button>
                </el-form-item>

                <el-form-item label="频率配置" prop="emergeData2">
                    <div v-if="!isShowBtn2" v-for="(item1,index) in emergeData2" :key="index">
                        <el-select v-model="item1.type"  placeholder="每月" size="small" >
                            <el-option
                                    v-for="item in timeType"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                        <el-select size="small" v-if="item1.type == 2" v-model="item1.day"  placeholder="日">
                            <el-option
                                    v-for="item in day"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                        <el-select size="small" v-if="item1.type == 1" v-model="item1.week"  placeholder="星期">
                            <el-option
                                    v-for="item in week"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                        <el-select size="small" v-model="item1.hour" placeholder="时">
                            <el-option
                                    v-for="item in hour"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                        <el-select size="small" v-model="item1.miu" placeholder="分">
                            <el-option
                                    v-for="item in miu"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>

                        <el-button size="small" type="danger" icon="el-icon-delete" style="margin-left:20px" @click="handDelEme2(index)" circle></el-button>
                    </div>
                    <el-button style="width:500px" @click="handleAddEme2()" plain>添加</el-button>
                </el-form-item>
            </el-form>
            <el-button type="primary" class="addBtn" @click="submitForm('ruleForm')">确定</el-button>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
          // 表单数据验证
          var checkPointId = (rule, value, callback) => {
            if(this.emergeData1.length === 0) {
              return callback(new Error('您未选择巡检点'))
            }else{
              for(let i in this.emergeData1) {
                if(!this.emergeData1[i].pointId){
                  return callback(new Error('您有添加的巡检点，但未选择'))
                }
              }
            }
            callback()
          };
          var checkFrequency = (rule, value, callback) => {
            if(!this.emergeData2.length){
              return callback(new Error('请选择巡检频率'))
            }else{
              // for(let j in this.emergeData2) {
              //   for(let k of this.emergeData2[j]){
              //     console.log(this.emergeData2[j][k])
              //     if(!this.emergeData2[j][k]){
              //       return callback(new Error('请填写频率配置'))
              //     }
              //   }
              // }
              callback()
            }
          };
          var checkUser = (rule, value, callback) => {
            if(!this.userIds.length) {
              return callback(new Error('请选择巡检人'))
            }else{
              callback()
            }
          };
            return {
                isAdd:true,
                isOrder: 0,
                ruleForm: {
                  name: "",
                  isOrder: 0,
                  pointId: [],
                  frequency: [],
                },
                rules: {
                  name: [{required: true, message: "请输入名称", trigger: 'blur'}],
                  remark: [{required: true, message: "请输入描述", trigger: 'blur'}],
                  userIds: [{required: true, validator: checkUser}],
                  duration: [{required: true, message: "请输入持续时间", trigger: 'blur'}],
                  // isOrder: [{required: true, message: "请选择", trigger: 'blur'}],
                  emergeData1: [{required: true, validator: checkPointId}],
                  emergeData2: [{required: true, validator: checkFrequency}],
                },
                timeType:[
                    {
                        id:0,
                        name:"每天"
                    },
                    {
                        id:1,
                        name:"每周"
                    },
                    {
                        id:2,
                        name:"每月"
                    },
                ],
                day:[
                    {id:1, name:"1日"},{id:2, name:"2日"},{id:3, name:"3日"},{id:4, name:"4日"},{id:5, name:"5日"},
                    {id:6, name:"6日"},{id:7, name:"7日"},{id:8, name:"8日"},{id:9, name:"9日"},{id:10, name:"10日"},
                    {id:11, name:"11日"},{id:12, name:"12日"},{id:13, name:"13日"},{id:14, name:"14日"},{id:15, name:"15日"},
                    {id:16, name:"16日"},{id:17, name:"17日"},{id:18, name:"18日"},{id:19, name:"19日"},{id:20, name:"20日"},
                    {id:21, name:"21日"},{id:22, name:"22日"},{id:23, name:"23日"},{id:24, name:"24日"},{id:25, name:"25日"},
                    {id:26, name:"26日"},{id:27, name:"27日"},{id:28, name:"28日"},{id:29, name:"29日"},
                    {id:30, name:"30日"},{id:31, name:"31日"}
                ],
				week:[
				    {id:1, name:"星期一"},{id:2, name:"星期二"},{id:3, name:"星期三"},{id:4, name:"星期四"},
					{id:5, name:"星期五"},{id:6, name:"星期六"},{id:7, name:"星期日"}
				],
                hour:[
                    {id:1, name:"1时"},{id:2, name:"2时"},{id:3, name:"3时"},{id:4, name:"4时"},{id:5, name:"5时"},
                    {id:6, name:"6时"},{id:7, name:"7时"},{id:8, name:"8时"},{id:9, name:"9时"},{id:10, name:"10时"},
                    {id:11, name:"11时"},{id:12, name:"12时"},{id:13, name:"13时"},{id:14, name:"14时"},{id:15, name:"15时"},
                    {id:16, name:"16时"},{id:17, name:"17时"},{id:18, name:"18时"},{id:19, name:"19时"},{id:20, name:"20时"},
                    {id:21, name:"21时"},{id:22, name:"22时"},{id:23, name:"23时"},
                ],
                miu:[
                    {id:0, name:"0分"},{id:1, name:"1分"},{id:2, name:"2分"},{id:3, name:"3分"},{id:4, name:"4分"},{id:5, name:"5分"},
                    {id:6, name:"6分"},{id:7, name:"7分"},{id:8, name:"8分"},{id:9, name:"9分"},{id:10, name:"10分"},
                    {id:11, name:"11分"},{id:12, name:"12分"},{id:13, name:"13分"},{id:14, name:"14分"},{id:15, name:"15分"},
                    {id:16, name:"16分"},{id:17, name:"17分"},{id:18, name:"18分"},{id:19, name:"19分"},{id:20, name:"20分"},
                    {id:21, name:"21分"},{id:22, name:"22分"},{id:23, name:"23分"},{id:24, name:"24分"},{id:25, name:"25分"},
                    {id:26, name:"26分"},{id:27, name:"27分"},{id:28, name:"28分"},{id:29, name:"29分"},{id:30, name:"30分"},
                    {id:31, name:"31分"},{id:32, name:"32分"},{id:33, name:"33分"},{id:34, name:"34分"},{id:35, name:"35分"},
                    {id:36, name:"36分"},{id:37, name:"37分"},{id:38, name:"38分"},{id:39, name:"39分"},{id:40, name:"40分"},
                    {id:41, name:"41分"},{id:42, name:"42分"},{id:43, name:"43分"},{id:44, name:"44分"},{id:45, name:"45分"},
                    {id:46, name:"46分"},{id:47, name:"47分"},{id:48, name:"48分"},{id:49, name:"49分"},{id:50, name:"50分"},
                    {id:51, name:"51分"},{id:52, name:"52分"},{id:53, name:"53分"},{id:54, name:"54分"},{id:55, name:"55分"},
                    {id:56, name:"56分"},{id:57, name:"57分"},{id:58, name:"58分"},{id:59, name:"59分"}

                ],
                userIds:[],
                userData:[],
                getObj: {},
                pointData:[],
                emergeData1:[],
                emergeData2:[],
                isShowBtn: true,
                isShowBtn2: true,
            };
        },
        mounted:function(){
            this.getAllUser();
            this.getPoint();
            this.getAllUser();

        },
        methods: {
            handleChange(value) {
                console.log(value);
            },
            //获取所有用户信息
            getAllUser() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getAllUser)
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.userData = res.body.data;
                    });
            },
            getPoint(){
                this.componentsMoudel.httpRequest
                    .getRequestHander("/inspectioncheckpoint/getAll")
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.pointData = res.body.data;
                    });
            },

            // 选择是否按顺序巡检
            checkBoxChange(val) {
              this.ruleForm.isOrder = val
            },
            
            submitForm() {
                let url = "";
                if (this.isAdd){
                    url = "/inspectionroute/save";
                } else{
                    url = "/inspectionroute/update";
                }
                this.$refs['ruleForm'].validate((valid) => {
                  if (valid) {
                    this.ruleForm.config = JSON.stringify(this.emergeData2);
                    // console.log(this.ruleForm.config)
                    this.ruleForm.userIds = JSON.stringify(this.userIds);
                    let arr = [];
                    for (var i = 0; i < this.emergeData1.length; i++) {
                        arr.push(this.emergeData1[i].pointId);
                    }
                    this.ruleForm.points = JSON.stringify(arr);
                    this.componentsMoudel.httpRequest
                    .getRequestHander(url)
                    .openLoad()
                    .startPost(this.ruleForm)
                    .then((res) => {
                        if (res.result == "success") {
                            this.$router.push({
                                path: "/processManager/insPath",
                            });
                        }
                    });
                  } else {
                    return false;
                  }
                });
            },
            handDelEme1(index) {
                // console.log(index);
                this.emergeData1.splice(index, 1);
            },
            handleAddEme1() {
                this.isShowBtn = false;
                this.emergeData1.push({
                });
            },
            handDelEme2(index) {
                // console.log(index);
                this.emergeData2.splice(index, 1);
            },
            handleAddEme2() {
                this.isShowBtn2 = false;
                this.emergeData2.push({

                    type: 0,
                });
            },
        },
        created() {
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.ruleForm = obj;
                this.isAdd = false;
                for (let i = 0; i < obj.userVos.length; i++) {
                    let objElement = obj.userVos[i].id;
                    this.userIds.push(objElement);
                }
                for (let j = 0; j < obj.inspectionCheckPointVos.length; j++) {
                    let objElement = obj.inspectionCheckPointVos[j].id;
                    this.emergeData1.push({
                        pointId:objElement
                    });
                }
                this.handleAddEme1();
                let length = this.emergeData1.length;
                this.emergeData1.splice(length-1, 1);
                let config = JSON.parse(obj.config);
                // "[{"type":0,"hour":7,"miu":7}]
                for (let m = 0; m < config.length; m++) {
                    this.emergeData2.push({
                        type:config[m].type,
                        day:config[m].day,
						week: config[m].week,
                        hour:config[m].hour,
                        miu:config[m].miu,
                    });
                }
                this.handleAddEme2();
                let length2 = this.emergeData2.length;
                this.emergeData2.splice(length2-1, 1);
            } else {
                this.ruleForm = {
                };
            }
        },
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }
</style>
